import { Window } from "@progress/kendo-react-dialogs";
import { Label } from "@progress/kendo-react-labels";
import { PDFExport } from "@progress/kendo-react-pdf";
import * as React from "react";
import PrintButton from "../../Buttons/PrintButton";
import { Section } from "../../Common/UI/SectionComponent";
import { showPrintPreviewWindow, template } from "./EditEntrySignals";

export const EntryPrintPreviewWindow = () => {
  const pdfExportComponent = React.useRef(null);
  const exportPDFWithComponent = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };

  if (!showPrintPreviewWindow.value) return null;

  return (
    <Window
      title={"Print Preview"}
      onClose={() => (showPrintPreviewWindow.value = false)}
      initialHeight={850}
      initialWidth={1100}
    >
      <div style={{ marginLeft: "64rem" }}>
        <PrintButton
          name={"btnPrint_" + template.value?.templateName}
          onClick={exportPDFWithComponent}
        />
      </div>

      <form className="k-form">
        <PDFExport
          ref={pdfExportComponent}
          paperSize="A4"
          margin="1cm"
          scale={0.6}
        >
          {template?.value?.sections?.map((section) => {
            return section?.fields?.map((field, fIndex) => {
              if (field.fieldType === "Index") {
                return (
                  <div
                    data-testid={field?.fieldName + "_" + fIndex}
                    key={field?.fieldName}
                  >
                    <Label
                      style={{
                        fontSize: `${field.properties?.fontSize || 12}px`,
                        fontWeight: field.properties?.fontWeight || "normal",
                        paddingTop: `${field.properties?.paddingTop || 0}px`,
                        paddingRight: `${field.properties?.paddingRight || 0}px`,
                        paddingBottom: `${field.properties?.paddingBottom || 0}px`,
                        paddingLeft: `${field.properties?.paddingLeft || 0}px`,
                      }}
                      id={field?.fieldName + "_label"}
                    >
                      {field.value}
                    </Label>
                  </div>
                );
              } else {
                return null;
              }
            });
          })}
          <Section isPrintPreview={true} />
        </PDFExport>
      </form>
    </Window>
  );
};
